export default __webpack_public_path__ + "static/media/icn-padlock-locked.0602ba33.svg";